import { Action } from 'redux';

export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export interface LoginRequestAction extends Action {
  type: typeof LOGIN_REQUEST;
  payload: {
    login: string;
    password: string;
    then?: (action: LoginSuccessAction) => void;
  };
}

export interface LoginFailureAction extends Action {
  type: typeof LOGIN_FAILURE;
  error: string;
}

export interface LoginSuccessAction extends Action {
  type: typeof LOGIN_SUCCESS;
  payload: { session: any; user: any };
}

export interface LogoutRequestAction extends Action {
  type: typeof LOGOUT_REQUEST;
  payload: { then?: (action: LogoutSuccessAction) => void };
}

export interface LogoutFailureAction extends Action {
  type: typeof LOGOUT_FAILURE;
  error: string;
}

export interface LogoutSuccessAction extends Action {
  type: typeof LOGOUT_SUCCESS;
}

export type AuthAction =
  | LoginFailureAction
  | LoginRequestAction
  | LoginSuccessAction
  | LogoutFailureAction
  | LogoutRequestAction
  | LogoutSuccessAction;
